(function() {
  const PROTECTION_PRODUCT_HANDLE = 'shipping-protection-4';
  const CHECKOUT_PATH = '/checkout';
  let protectionVariantIdPromise = null;
  let ensureProtectionPromise = null;

  function getProtectionVariantId() {
    if (!protectionVariantIdPromise) {
      protectionVariantIdPromise = fetch(`/products/${PROTECTION_PRODUCT_HANDLE}.js`, {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then((response) => {
          if (!response.ok) throw new Error('Could not load protection product.');
          return response.json();
        })
        .then((product) => {
          const variant = Array.isArray(product.variants) ? product.variants.find((item) => item.available) || product.variants[0] : null;
          if (!variant || !variant.id) throw new Error('No valid protection variant found.');
          return variant.id;
        });
    }
    return protectionVariantIdPromise;
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      if (!response.ok) throw new Error('Could not load cart.');
      return response.json();
    });
  }

  function isProtectionItem(item) {
    return item.handle === PROTECTION_PRODUCT_HANDLE || item.url === `/products/${PROTECTION_PRODUCT_HANDLE}`;
  }

  function isGiftCard(item) {
    return (item.product_type || '').toLowerCase() === 'gift card';
  }

  function cartNeedsProtection(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return false;

    const hasProtection = cart.items.some(isProtectionItem);
    if (hasProtection) return false;

    const nonProtectionItems = cart.items.filter((item) => !isProtectionItem(item));
    if (!nonProtectionItems.length) return false;

    // Skip auto-add when every non-protection line item is a Gift Card.
    const allGiftCards = nonProtectionItems.every(isGiftCard);
    if (allGiftCards) return false;

    return true;
  }

  function addProtectionToCart() {
    return getProtectionVariantId().then((variantId) => {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              '_auto_added': 'true'
            }
          }]
        })
      }).then((response) => {
        if (!response.ok) throw new Error('Could not add protection to cart.');
        return response.json();
      });
    });
  }

  function ensureProtectionInCart() {
    if (!ensureProtectionPromise) {
      ensureProtectionPromise = getCart()
        .then((cart) => {
          if (!cartNeedsProtection(cart)) return cart;
          return addProtectionToCart();
        })
        .catch((error) => {
          console.error('Auto checkout protection error:', error);
          return null;
        })
        .finally(() => {
          ensureProtectionPromise = null;
        });
    }
    return ensureProtectionPromise;
  }

  function continueCheckout(submitter) {
    const form = submitter && (submitter.form || submitter.closest('form'));

    if (form) {
      form.dataset.autoProtectionReady = 'true';
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
        return;
      }
      form.submit();
      return;
    }

    window.location.href = CHECKOUT_PATH;
  }

  document.addEventListener('submit', function(event) {
    const form = event.target;
    const submitter = event.submitter;

    if (!(form instanceof HTMLFormElement)) return;
    if (!submitter || submitter.name !== 'checkout') return;

    if (form.dataset.autoProtectionReady === 'true') {
      delete form.dataset.autoProtectionReady;
      return;
    }

    event.preventDefault();
    ensureProtectionInCart().finally(function() {
      continueCheckout(submitter);
    });
  }, true);

  document.addEventListener('click', function(event) {
    const checkoutButton = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!checkoutButton) return;

    const form = checkoutButton.form || checkoutButton.closest('form');
    if (form && form.dataset.autoProtectionReady === 'true') return;

    event.preventDefault();
    ensureProtectionInCart().finally(function() {
      continueCheckout(checkoutButton);
    });
  }, true);
})();
